// Brand & external links for TrustHer Home
export const BRAND = {
    name: "TrustHer Home",
    tagline: "Confidence you can let in.",
    domain: "trustherhome",
    email: "hello@trustherhome.com",
};

export const SOCIAL_LINKS = {
    instagram: "https://www.instagram.com/trustherhome",
    facebook: "https://www.facebook.com/trustherhome",
    tiktok: "https://www.tiktok.com/@trustherhome",
    linkedin: "https://www.linkedin.com/in/trustherhome/",
};

// External Airtable Form embed URLs
export const FORMS = {
    homeownerCommunity:
        "https://airtable.com/embed/apprjCNs2ynkGmZff/pagkGypHeYNplpIMc/form",
    foundingProvider:
        "https://airtable.com/embed/apprjCNs2ynkGmZff/pag9o08nL1RyTZsCl/form",
};

export const LOGOS = {
    wordmarkDark: "/logos/logo-wordmark-dark.png",
    wordmarkCream: "/logos/logo-wordmark-cream.png",
    markDark: "/logos/logo-mark-dark.png",
    markCream: "/logos/logo-mark-cream.png",
};
